import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { GA_ENABLED, GA_ID } from "config";

export const initializeGoogleAnalytics = () => {
  if (!GA_ENABLED || !GA_ID || window.gtag) {
    return;
  }

  const script = document.createElement("script");
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;

  document.head.appendChild(script);

  window.dataLayer = window.dataLayer || [];

  window.gtag = function () {
    window.dataLayer.push(arguments);
  };

  window.gtag("js", new Date());
  window.gtag("config", GA_ID);
};

const GoogleAnalytics = () => {
  const location = useLocation();

  useEffect(() => {
    initializeGoogleAnalytics();
  }, []);

  useEffect(() => {
    if (!GA_ENABLED || !window.gtag) {
      return;
    }

    window.gtag("event", "page_view", {
      page_path: location.pathname + location.search,
      page_location: window.location.href,
    });
  }, [location]);

  return null;
};

export default GoogleAnalytics;